import React from 'react'
import About360 from './About360/About360'
import WhyHIreUs from './WhyHireUs/WhyHIreUs'
import Engagement from './Engagement/Engagement'
import Hww from '../Home/Hww/Hww'
import Hmclient from '../Home/Hmclient/Hmclient'
import Abtcont from './Abtcont/Abtcont'

function Aboutpage() {
  return (
    <>
      <About360/>
      <WhyHIreUs/>
      <Engagement/>
      <Hww />
      <Hmclient />
      <Abtcont/>
    </>
  )
}

export default Aboutpage
